import { useState } from "react";
import { useDispatch } from "react-redux";
import axios from "../../axios";
import { deleteStorageAuth, getStorageAuth } from "./methods";
import { userUnauthenticatedAction } from "./reducer";
import AuthService from "./AuthService";

const useLogout = (onSuccess = () => {}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const submit = () => {
    if (loading) {
      return;
    }

    const accessToken = getStorageAuth().access_token;

    if (accessToken) {
      setLoading(true);
      axios.post("auth/logout").then(
        () => {
          AuthService.sendBroadCastMessage("logout");
          deleteStorageAuth();
          setLoading(false);
          dispatch(userUnauthenticatedAction());
          onSuccess();
        },
        () => {
          AuthService.sendBroadCastMessage("logout");
          deleteStorageAuth();
          setLoading(false);
          dispatch(userUnauthenticatedAction());
          onSuccess();
        }
      );
    } else {
      dispatch(userUnauthenticatedAction());
    }
  };

  return {
    loading,
    submit
  };
};

export default useLogout;
